
<div class='alert account-ag' *ngIf="dialogValue.value == 2">
    <h4>Account Aggregator <span><img src="assets/icon1.png" alt=""></span></h4>
    <p mat-dialog-title>Account aggregation sometimes also known as financial data aggregation 
        is a method that involves compiling information from different accounts, which may include 
        bank accounts, credit card accounts, investment accounts, and other consumer or business accounts, 
        into a single place.</p>

    <hr>
    <mat-dialog-content class="content-ag">If you have an account aggregator id <br>
        <button class="btn-ag" (click)="closeDialog(2)">Proceed</button> <br>
        <label class="label-ag">Create New One?</label>
    </mat-dialog-content>
</div>